import { useMemo } from "react";
import { ADMIN_RESELLER_ROLE_ID } from "../../hooks/useIsReseller";
import { useUserStore } from "../../store/userStore";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import {
  PAPELERA_ENTITIES,
  type PapeleraEntity,
  type PapeleraRole,
} from "./papeleraConfig";

export const ADMIN_ROLE_NAME = "admin";

export interface PapeleraPermissions {
  isAdmin: boolean;
  isReseller: boolean;
  canAccess: boolean;
  canManage: (entity: PapeleraEntity) => boolean;
  manageableEntities: PapeleraEntity[];
}

export function usePapeleraPermissions(): PapeleraPermissions {
  const user = useUserStore((s) => s.user);
  const activeCompanyId = useCompaniesStore((s) => s.companyId);

  return useMemo(() => {
    const roleId = user?.role_id || localStorage.getItem("userRoleId") || "";
    const roleName = (localStorage.getItem("userRole") || "").toLowerCase();

    const isReseller = roleId === ADMIN_RESELLER_ROLE_ID;
    const isAdmin = roleName === ADMIN_ROLE_NAME;

    const roles: PapeleraRole[] = [];
    if (isAdmin) roles.push("admin");
    if (isReseller) roles.push("reseller");

    const canManage = (entity: PapeleraEntity) => {
      if (!entity.roles.some((r) => roles.includes(r))) return false;
      // Entidades restringidas a compañías piloto: solo si la compañía activa
      // está en la lista.
      if (entity.companyAllowList) {
        return (
          !!activeCompanyId && entity.companyAllowList.includes(activeCompanyId)
        );
      }
      return true;
    };

    return {
      isAdmin,
      isReseller,
      canAccess: isAdmin || isReseller,
      canManage,
      manageableEntities: PAPELERA_ENTITIES.filter(canManage),
    };
  }, [user, activeCompanyId]);
}
